import React, { useState } from 'react';
import { YMInitializer } from 'react-yandex-metrika';
// import logo from './logo.svg';
import './App.css';
// import MaterialButton from './components/Button'
import MainPage from './components/Main'
import { createMuiTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import CookiesLocked from './components/Errors/CookiesLocked';
import 'airbnb-js-shims';

// import createPalette from '@material-ui/core/styles/createPalette';
// import CeraRegularWoff from './font/Regular.woff';
// import CeraMediumWoff from './font/Medium.woff';

// const ceraRegular = {
//   fontFamily: 'Cera',
//   fontStyle: 'normal',
//   fontDisplay: 'swap',
//   fontWeight: 400,
//   src: `
//     local('Cera'),
//     local('Cera-Regular'),
//     url(${CeraRegularWoff}) format('woff')
//   `,
//   unicodeRange:
//     'U+0000-00FF, U+0400-04FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF', 
// };

// const ceraMedium = {
//   fontFamily: 'Cera',
//   fontStyle: 'normal',
//   fontDisplay: 'swap',
//   fontWeight: 500,
//   src: `
//     local('Cera'),
//     local('Cera-Medium'),
//     url(${CeraMediumWoff}) format('woff')
//   `,
//   unicodeRange:
//     'U+0000-00FF, U+0400-04FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF', 
// };

const theme = createMuiTheme({
  overflowY: 'scroll',
  typography: {
    fontFamily: 'Cera CY',
  },

  // overrides: {
  //   MuiCssBaseline: {
  //     '@global': {
  //       '@font-face': [ceraRegular],
  //       // '@font-face': [ceraMedium],
  //     },
  //   },
  // },

  //   typography: {
  //     fontFamily: [
  //       'Cera',
  //       // '-apple-system',
  //       // 'BlinkMacSystemFont',
  //       // '"Segoe UI"',
  //       // 'Roboto',
  //       // '"Helvetica Neue"',
  //       // 'Arial',
  //       // 'sans-serif',
  //       // '"Apple Color Emoji"',
  //       // '"Segoe UI Emoji"',
  //       // '"Segoe UI Symbol"',
  //     ].join(','),
  //   },

  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: '#F6F6FB',
      // icons: '#FFF'
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },

    secondary: {
      light: '#0066ff',
      main: '#F6F6FB',
      // dark: will be calculated from palette.secondary.main,
      contrastText: '#000000',
    },

    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    // contrastThreshold: 3,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    // tonalOffset: 0.2,
  },

  breakpoints: {
    values: {
      xs: 360,
      sm: 696,
      md: 1032,
      lg: 1366,
      xl: 1702,
    },
  },
});

function App() {
  const COUNTER_ID = 12245119;
  const [isMetrikaActive, _isMetrikaActive] = useState(false);

  const getItemFromStorage = (item) => {
    try {
      return (
        <ThemeProvider theme={theme}>
          {JSON.parse(localStorage.getItem(item)) || []}

          <MainPage
            isMetrikaActive={isMetrikaActive}
            setMetrikaActive={_isMetrikaActive}
          />

        </ThemeProvider>
      )
    } catch (e) {
      return (
        <CookiesLocked />
      )
    }
  }

  return (
    <React.Fragment>
      {getItemFromStorage()}

      {isMetrikaActive && (
        <YMInitializer
          accounts={[COUNTER_ID]}
          options={{
            clickmap: true,
            trackLinks: true,
            trackHash: true,
            accurateTrackBounce: true
          }}
        />
      )}
    </React.Fragment>
  );
}

export default App;
